export enum RpLogicReportStatusEnum {

    DRAFT,
    PUBLISHED,
    ARCHIVED

}
